import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import GoogleAnalytics from "components/analytics/GoogleAnalytics";
import NotFound from "pages/NotFound";
import TutorialsPage from './pages/tutorials';
import SubscriptionPage from './pages/subscription';
import Homepage from './pages/homepage';
import USWaitlistPage from './pages/us-waitlist';
import EUWaitlistPage from './pages/eu-waitlist';
import PrivacyPage from './pages/privacy';
import TermsPage from './pages/terms';
import SecurityPage from './pages/security';
import UpdatesPage from './pages/updates';
import FaqPage from './pages/faq';
import FactsForAiPage from './pages/facts-for-ai';
import CharityPage from './pages/charity';
import SheetsPage from './pages/sheets';
import SheetsSupportPage from './pages/support-sheets';
import SheetsGuidePage from './pages/support-sheets/guide';
import SheetsSetupGuidePage from './pages/sheets-setup-guide';
import SheetsGoogleReviewPage from './pages/sheets-google-review';
import AgencyPage from './pages/agency';
import OuroMobileHandoffPage from './pages/jessica-mobile';
import AccountingMarketingPage from './pages/accounting-marketing';
import InkLandingPage from './pages/ink';
import InkGetPage from './pages/ink/get';
import InkFeedbackPage from './pages/ink/feedback';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <GoogleAnalytics />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/tutorials" element={<TutorialsPage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/homepage" element={<Navigate to="/" replace />} />
        <Route path="/us-waitlist" element={<USWaitlistPage />} />
        <Route path="/eu-waitlist" element={<EUWaitlistPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/updates" element={<UpdatesPage />} />
        <Route path="/charity" element={<CharityPage />} />
        <Route path="/sheets" element={<SheetsPage />} />
        <Route path="/support-sheets" element={<SheetsSupportPage />} />
        <Route path="/support-sheets/guide" element={<SheetsGuidePage />} />
        <Route path="/sheets-setup-guide" element={<SheetsSetupGuidePage />} />
        <Route path="/sheets-google-review" element={<SheetsGoogleReviewPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/facts-for-ai" element={<FactsForAiPage />} />
        <Route path="/accounting" element={<AccountingMarketingPage />} />
        <Route path="/ink" element={<InkLandingPage />} />
        <Route path="/get-ink" element={<InkGetPage />} />
        <Route path="/ink/report-bug" element={<InkFeedbackPage key="bug" type="bug" />} />
        <Route path="/ink/suggest-feature" element={<InkFeedbackPage key="feature" type="feature" />} />
        <Route path="/agency" element={<AgencyPage />} />
        <Route path="/ouro" element={<OuroMobileHandoffPage />} />
        <Route path="/ouro/mobile" element={<OuroMobileHandoffPage />} />
        <Route path="/jessica" element={<Navigate to="/ouro" replace />} />
        <Route path="/jessica/mobile" element={<Navigate to="/ouro" replace />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;